<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh @invoke-method="dbGetLoginAttempts()" permanent></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams" @open="getArrayData()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.login"
                                            :label="$t('lang.username')"
                                            :items="login_usernames"
                                            item-value="login"
                                            item-text="login"
                                            prepend-icon="contacts"
                                            single-line
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </v-list>
                            </bc-search-menu>
                            <!-- <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobileList"
                            ></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="{ 'pa-0': $bp.smallScreen }">
                    <v-data-table
                        :headers="headers"
                        :items="login_attempts"
                        hide-actions
                        :no-data-text="$t('lang.no_data_available')"
                        :class="{ 'prevent-click': !hasPerm('configuration.update') }"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="clickable" @mouseup.left="(loginAttemptsDialog = true), (activeLoginAttempt = props.item)">{{ props.item.login }}</td>
                            <td class="clickable" @mouseup.left="(loginAttemptsDialog = true), (activeLoginAttempt = props.item)">
                                {{ props.item.ip_address }}
                            </td>
                            <td class="clickable" @mouseup.left="(loginAttemptsDialog = true), (activeLoginAttempt = props.item)">{{ props.item.status }}</td>
                            <td class="clickable" @mouseup.left="(loginAttemptsDialog = true), (activeLoginAttempt = props.item)">{{ props.item.reason }}</td>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="settings_login_attempts"></bc-pagination>
                </v-card-text>
            </v-card>
        </v-container>
        <bc-dialog :value="loginAttemptsDialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.login_attempt") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="loginAttemptsDialog"
                        :dialog-status="loginAttemptsDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="prevent-click">
                    <v-form>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field readonly v-model="activeLoginAttempt.login" :label="$t('lang.username')" maxLength="100"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field readonly v-model="activeLoginAttempt.ip_address" :label="$t('lang.ip_address')" maxLength="45"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field readonly v-model="activeLoginAttempt.status" :label="$t('lang.status')"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea
                                        readonly
                                        v-model="activeLoginAttempt.reason"
                                        :label="$t('lang.reason')"
                                        maxLength="255"
                                        auto-grow
                                        rows="1"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                    <delete-confirmation-dialog
                        ref="deleteConfirmationLoginAttemptDialog"
                        :heading="$t('lang.confirm_delete_header')"
                        :message="$t('lang.delete_login_attempt')"
                        @onConfirm="onDeleteLoginAttempt(activeLoginAttempt.id)"
                    ></delete-confirmation-dialog>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="hasPerm('configuration.delete')" color="error" @mouseup.left="deleteLoginAttempt()">{{ $t("lang.delete") }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="loginAttemptsDialog = false">{{ $t("lang.close") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.login"), sortable: false },
                { text: this.$t("lang.ip_address"), sortable: false },
                { text: this.$t("lang.status"), sortable: false },
                { text: this.$t("lang.reason"), sortable: false },
            ],
            activeLoginAttempt: {},
            login_attempts: [],
            login_usernames: null,
            filter: {
                search: "",
                login: "",
                status: "fail",
                page_size: 0,
                page_num: 1,
            },
            page: {},
            loginAttemptsDialog: false,
            mobileList: [{ title: this.$t("lang.refresh"), action: "dbGetLoginAttempts" }],
            dbGetLoginAttempts: _.debounce(this.getLoginAttempts, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchLoginAttempts", {
                url: "login_attempts",
                method: "get",
                stateProperty: "login_attempts",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.login_attempts) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.login_attempts = data.login_attempts;
                        vm.page = data.page;
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchLoginAttempts", {
                url: "login_attempts",
                method: "get",
                stateProperty: "login_attempts",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.login_attempts) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.login_attempts = data.login_attempts;
                    this.page = data.page;
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapGetters({
            default_filter: "login_attempts_filter",
        }),
        ...mapGetters(["filter_menu"]),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        getArrayData() {
            if (this.login_usernames == null) this.getLoginUsernames();
        },
        getLoginAttempts(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchLoginAttempts", {
                    url: "login_attempts",
                    method: "get",
                    stateProperty: "login_attempts",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.login_attempts) {
                        this.login_attempts = data.login_attempts;
                        this.page = data.page;
                    } else {
                        this.$router.push({ name: "dashboard" });
                    }
                })
                .finally(() => {
                    status ? this.finishLoader(true) : null;
                    if (this.$refs.deleteConfirmationLoginAttemptDialog) this.$refs.deleteConfirmationLoginAttemptDialog.close();
                    this.loginAttemptsDialog = false;
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getLoginUsernames() {
            this.$store
                .dispatch("fetchLoginAttempts", {
                    url: "login_attempts",
                    method: "get",
                })
                .then((data) => {
                    this.login_usernames = data.login_attempts;
                });
        },
        // open dialog to delete sensor
        deleteLoginAttempt() {
            this.$refs.deleteConfirmationLoginAttemptDialog.openDialog();
        },
        // delete sensor
        onDeleteLoginAttempt(id) {
            const _id = id;
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchLoginAttempts", {
                    url: "login_attempts/" + _id,
                    method: "delete",
                })
                .then((data) => {
                    if (this.login_attempts && this.login_attempts.length == 1) {
                        this.filter.search = "";
                        this.filter.login = "";
                    }
                    this.getLoginAttempts(false);
                });
        },
    },
};
</script>
